module.exports = __webpack_public_path__ + "images/playlist_600.98ecca56f1b8317ee8d8748d6c98391b.png";